import React, { useMemo } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material';

/**
 * The app's theme, with ripples switched off for everything Livy renders.
 *
 * Not a preference. MUI paints a TouchRipple span as the last child of every ButtonBase, and an
 * inverting dark-mode extension gives that span an opaque background, which lands on top of the
 * label. Every rippled control in here rendered as a blank pill for anyone running one: the
 * suggestion chips looked like they had stopped appearing, when the model had been sending them
 * all along.
 *
 * Scoped to Livy rather than set globally so it cannot change how the rest of the app behaves.
 */
export function LivyTheme(_ref) {
  let children = _ref.children;
  const parent = useTheme();
  const theme = useMemo(() => createTheme(parent, {
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      }
    }
  }), [parent]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
}